/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaComunicazioneDestinatariConteggioDTO } from '../model/models';
import { ServizioMensaComunicazioneEmailForm } from '../model/models';
import { ServizioMensaComunicazioneSmsForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ContaServizioMensaComunicazioneDestinatariRequestParams {
    gestioneMenseServizioId: string;
    email?: boolean;
    scuolaId?: string;
    classe?: string;
    sezione?: string;
}

export interface InviaServizioMensaComunicazioneEmailRequestParams {
    gestioneMenseServizioId: string;
    comunicazione: ServizioMensaComunicazioneEmailForm;
    files?: Array<Blob>;
}

export interface InviaServizioMensaComunicazioneSmsRequestParams {
    gestioneMenseServizioId: string;
    servizioMensaComunicazioneSmsForm: ServizioMensaComunicazioneSmsForm;
}


export interface ServizioMensaComunicazioniServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Conta i destinatari di una comunicazione, senza inviarla.
     * Anteprima numerica: quanti recapiti distinti riceverebbero il messaggio con i filtri dati (scuola/classe/sezione; assenti &#x3D; tutti i genitori del servizio) e quanti genitori sarebbero scartati perche\&#39; senza recapito. Riusa la stessa risoluzione destinatari dell\&#39;invio, deduplica inclusa. Solo numeri: nessun dato personale.
     * @endpoint get /api/v1/servizi/mensa/comunicazioni/destinatari/conteggio
* @param requestParameters
     */
    contaServizioMensaComunicazioneDestinatari(requestParameters: ContaServizioMensaComunicazioneDestinatariRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaComunicazioneDestinatariConteggioDTO>;

    /**
     * Invia una comunicazione email massiva ai genitori del servizio.
     * Invia (asincrono) una email a tutti i genitori distinti degli studenti non sospesi con Pratica accettata del servizio (header Gestione-Mense-Servizio-Id), con allegati e filtri opzionali (scuola/classe/sezione). In alternativa ai filtri, anagrafica_ids indica i genitori scelti uno per uno (anche con figli sospesi o Pratica non accettata). Ritorna subito 200.
     * @endpoint post /api/v1/servizi/mensa/comunicazioni/email
* @param requestParameters
     */
    inviaServizioMensaComunicazioneEmail(requestParameters: InviaServizioMensaComunicazioneEmailRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Invia una comunicazione SMS massiva ai genitori del servizio.
     * Invia (asincrono) un SMS a tutti i genitori distinti eleggibili del servizio (header Gestione-Mense-Servizio-Id), con filtri opzionali. Genitori senza cellulare saltati. Nessun filtro UserFilterType. In alternativa ai filtri, anagrafica_ids indica i genitori scelti uno per uno. Ritorna subito 200.
     * @endpoint post /api/v1/servizi/mensa/comunicazioni/sms
* @param requestParameters
     */
    inviaServizioMensaComunicazioneSms(requestParameters: InviaServizioMensaComunicazioneSmsRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
